export default {
  AJAX_PATH: "a",
};


// WEBPACK FOOTER //
// ../server/lib/constants.js